import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';

import { type QueryStateSchema, backwardsCompatabilityFactory, queryParam, queryStateParser } from './queryStateParser';

const QS_KEY = 'paneBankStatementOrganizerId';
const QS_TYPE: QueryStateSchema['type'] = 'bankStatementOrganizer';

export const useOpenBankStatementOrganizerPane = (): ((args: { bankStatementOrganizerId: string }) => void) => {
  const [bankStatementOrganizerIdDeprecated, setBankStatementOrganizerId] = useQueryState(QS_KEY);
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (bankStatementOrganizerIdDeprecated) {
      setBankStatementOrganizerId(null);
      setState(backwardsCompatabilityFactory({ id: bankStatementOrganizerIdDeprecated, type: QS_TYPE }));
    }
  }, [bankStatementOrganizerIdDeprecated]);

  return ({ bankStatementOrganizerId }) => {
    setState((prevState) => [
      ...(prevState || []),
      {
        id: bankStatementOrganizerId,
        key: nanoid(),
        type: QS_TYPE,
      },
    ]);
  };
};
